/* Pair Bundle: product-page tier picker + cart gift/upsell block. */
(() => {
  if (window.__saPairBundle) return;
  window.__saPairBundle = true;

  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  const refreshCart = () => {
    const items = document.querySelector('cart-drawer-items');
    if (items && typeof items.onCartUpdate === 'function') return items.onCartUpdate();
    if (location.pathname.endsWith('/cart')) location.reload();
  };

  const post = (url, body) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then((r) => r.json());

  class SaPairBundlePicker extends HTMLElement {
    connectedCallback() {
      this.price = parseInt(this.dataset.price, 10) || 0;
      this.addEventListener('change', (e) => {
        if (e.target.type !== 'radio') return;
        const qty = document.getElementById(`Quantity-${this.dataset.section}`);
        if (!qty) return;
        qty.value = e.target.value;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (window.subscribe && window.PUB_SUB_EVENTS) {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const v = event && event.data && event.data.variant;
          if (v && v.price) this.setPrice(v.price);
        });
      }
    }
    disconnectedCallback() {
      if (this.unsub) this.unsub();
    }
    setPrice(p) {
      this.price = p;
      this.querySelectorAll('[data-tier-price]').forEach((el) => {
        const q = parseInt(el.dataset.tierPrice, 10);
        el.textContent = money(q === 3 ? 3 * (p - Math.floor(p / 10)) : p * q);
      });
    }
  }

  class SaPairBundle extends HTMLElement {
    connectedCallback() {
      const pairs = parseInt(this.dataset.pairs, 10) || 0;
      const giftKeys = (this.dataset.giftKeys || '').split(',').filter(Boolean);
      const giftQty = parseInt(this.dataset.giftQty, 10) || 0;
      // The $0 gift is only for 2+ eligible pairs, one per order.
      const updates = {};
      if (pairs < 2) giftKeys.forEach((k) => (updates[k] = 0));
      else if (giftQty > 1) giftKeys.forEach((k, i) => (updates[k] = i === 0 ? 1 : 0));
      if (Object.keys(updates).length) {
        post('/cart/update.js', { updates }).then(refreshCart);
        return;
      }
      this.addEventListener('click', (e) => {
        const giftBtn = e.target.closest('[data-add-gift]');
        const upBtn = e.target.closest('[data-add-upsell]');
        if (!giftBtn && !upBtn) return;
        const btn = giftBtn || upBtn;
        const src = giftBtn ? this.querySelector('#SaPbGift') : document.getElementById(upBtn.dataset.addUpsell);
        if (!src || !src.value) return;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        post('/cart/add.js', { items: [{ id: parseInt(src.value, 10), quantity: 1 }] })
          .then(refreshCart)
          .catch(() => {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          });
      });
    }
  }

  if (!customElements.get('sa-pair-bundle-picker')) customElements.define('sa-pair-bundle-picker', SaPairBundlePicker);
  if (!customElements.get('sa-pair-bundle')) customElements.define('sa-pair-bundle', SaPairBundle);
})();
